import PropTypes from 'prop-types';
import Notifications from "./components/Notification/Notifications";
import Dialogs from "./components/Dialog/Dialogs";
import Modal from "./components/Modal";
import { createContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Context = /*#__PURE__*/createContext({});
var MinutemailerUI = function MinutemailerUI(_ref) {
  var t = _ref.t,
    children = _ref.children;
  return /*#__PURE__*/_jsxs(Context.Provider, {
    value: {
      t: t
    },
    children: [children, /*#__PURE__*/_jsx(Notifications, {}), /*#__PURE__*/_jsx(Dialogs, {}), /*#__PURE__*/_jsx(Modal, {})]
  });
};
MinutemailerUI.propTypes = {
  children: PropTypes.node.isRequired,
  t: PropTypes.func
};
MinutemailerUI.defaultProps = {
  t: function t(str) {
    return str;
  }
};
export default MinutemailerUI;